module.exports = function() {
  return new Worker(__webpack_public_path__ + "9e79c7408b25cde3ba97.worker.js");
};